// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2UxiF","list":"BalanceDue_list__1KoAE","listRow":"BalanceDue_listRow__2g2w3","total":"BalanceDue_total__1Lhh_"};